import { render } from "./SelectRoom.vue?vue&type=template&id=54df7b4d&scoped=true"
import script from "./SelectRoom.vue?vue&type=script&lang=js"
export * from "./SelectRoom.vue?vue&type=script&lang=js"

import "./SelectRoom.vue?vue&type=style&index=0&id=54df7b4d&lang=scss&scoped=true"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54df7b4d"]])

export default __exports__